<script>
	import { navigate } from 'svelte-routing';

	export let term = "";

	let searchInput;
	function submit(e) {
		let term = searchInput.value;
		e.preventDefault();
		navigate(`/search/${term}`);
	}
</script>

<style>
	#search-bar {
		/*position: fixed;
		top: 0;
		left: 0;
		right: 0;*/
		height: 50px;
		/*background: #EEE;*/
		text-align: center;
	}
	.icon {
		max-width: 26px;
		max-height: 26px;
		vertical-align: middle;
	}

	input[type="text"] {
		width: 300px;
		padding: 10px;
		margin: 0 20px;
		font-size: 16px;
		border: none;
		border-bottom: 1px solid #000;
		outline: none;
	}
	::placeholder {
		color: #AAA;
		opacity: 1;
	}
	input[type="submit"] {
		background: #EEE;
		border-radius: 10px;
		color: #000;
		padding: 10px 20px;
		border: none;
		cursor: pointer;
		background: #ec6a33;
		color: #FFF;
		border-radius: 5px;
		font-weight: 600;
	}
	button {
		background: transparent;
		border: none;
	}
</style>

<div id="search-bar">
	<form autocomplete="off" on:submit={submit}>
		<img class="icon" src="/find.png">
		<input type="text" autocomplete="off" bind:this={searchInput} name="term" placeholder="Search books..." value={term} />
		<input type="submit" value="Search" />
	</form>
</div>

